/* eslint-disable import/no-anonymous-default-export */
export default {
  main: '/',
  auth: '/auth',
  reg: '/registration',
  calculator: '/calculator',
  diary: '/diary',
}
